import { GET, setParams } from '../../_http';
import type { operations } from '@/types/schemas/api.main';
type controller = operations['BrokerCurrentUserController_get'];

export type BrokerCurrentUserResponse = controller['responses']['200']['content']['application/json'];

export const currentUser = GET('/brokers/user/current-user', setParams<undefined>)<BrokerCurrentUserResponse>;
